import * as Type from './actionsTypes';

const INITIAL_STATE = {
  municipioUsuario: null,
  feriados: [],
  loadingCalendario: false,
  feriadosAdmin: [],
  loadingCalendarioAdmin: false,
  municipiosUsuariosAtivos: [],
  loadingMunicipiosUsuariosAtivos: false,
};

export default function (state = INITIAL_STATE, action) {
  switch (action.type) {
    case Type.CALENDARIO_FERIADO_LOAD_MUNICIPIO_USUARIO_SUCCESS: {
      return {
        ...state,
        municipioUsuario: action.data,
      };
    }
    case Type.CALENDARIO_FERIADO_LOAD_PUBLICO: {
      return {
        ...state,
        loadingCalendario: true,
      };
    }
    case Type.CALENDARIO_FERIADO_LOAD_PUBLICO_SUCCESS: {
      return {
        ...state,
        feriados: action.data,
        loadingCalendario: false,
      };
    }
    case Type.CALENDARIO_FERIADO_LOAD_PUBLICO_FAIL: {
      return {
        ...state,
        loadingCalendario: false,
      };
    }
    case Type.CALENDARIO_FERIADO_LOAD_ADMIN_CALENDAR: {
      return {
        ...state,
        loadingCalendarioAdmin: true,
      };
    }
    case Type.CALENDARIO_FERIADO_LOAD_ADMIN_CALENDAR_SUCCESS: {
      return {
        ...state,
        feriadosAdmin: Array.isArray(action.data) ? action.data : [],
        loadingCalendarioAdmin: false,
      };
    }
    case Type.CALENDARIO_FERIADO_LOAD_ADMIN_CALENDAR_FAIL: {
      return {
        ...state,
        feriadosAdmin: [],
        loadingCalendarioAdmin: false,
      };
    }
    case Type.CALENDARIO_FERIADO_LOAD_MUNICIPIOS_USUARIOS_ATIVOS: {
      return {
        ...state,
        loadingMunicipiosUsuariosAtivos: true,
      };
    }
    case Type.CALENDARIO_FERIADO_LOAD_MUNICIPIOS_USUARIOS_ATIVOS_SUCCESS: {
      return {
        ...state,
        municipiosUsuariosAtivos: Array.isArray(action.data) ? action.data : [],
        loadingMunicipiosUsuariosAtivos: false,
      };
    }
    case Type.CALENDARIO_FERIADO_LOAD_MUNICIPIOS_USUARIOS_ATIVOS_FAIL: {
      return {
        ...state,
        municipiosUsuariosAtivos: [],
        loadingMunicipiosUsuariosAtivos: false,
      };
    }
    case Type.CALENDARIO_FERIADO_CLEAN: {
      return INITIAL_STATE;
    }
    default:
      return state;
  }
}

export const getMunicipioUsuario = (state) => state.rootState.calendarioFeriado.municipioUsuario;
export const getFeriados = (state) => state.rootState.calendarioFeriado.feriados;
export const getLoadingCalendario = (state) => state.rootState.calendarioFeriado.loadingCalendario;
export const getFeriadosAdmin = (state) => state.rootState.calendarioFeriado.feriadosAdmin;
export const getLoadingCalendarioAdmin = (state) =>
  state.rootState.calendarioFeriado.loadingCalendarioAdmin;
export const getMunicipiosUsuariosAtivos = (state) =>
  state.rootState.calendarioFeriado.municipiosUsuariosAtivos;
export const getLoadingMunicipiosUsuariosAtivos = (state) =>
  state.rootState.calendarioFeriado.loadingMunicipiosUsuariosAtivos;
